export default __webpack_public_path__ + "static/media/socialchoice.9971d8ac.PNG";